// iOS home-screen (standalone) WebKit bug: on first cold launch the web view is
// created at a provisional size and 100dvh is resolved from it, without a later
// resize event to correct the CSS value — leaving a dead band at the bottom until
// the user app-switches. window.innerHeight / visualViewport do settle to the real
// size shortly after launch, so drive an --app-height variable from them and let
// the CSS use it with a 100dvh fallback.
export function installAppHeightSync() {
  // Deliberately window.innerHeight, not visualViewport.height: the visual
  // viewport shrinks while the iOS keyboard is open, and the layout must not.
  const sync = () => {
    let h = window.innerHeight;
    // iOS home-screen app (navigator.standalone is iOS-only): innerHeight can be
    // stale on cold launch too, but the web view spans the full physical screen
    // there, so the screen dimension is authoritative. iOS never swaps
    // screen.width/height on rotation, so pick the side matching orientation.
    if ((navigator as { standalone?: boolean }).standalone) {
      const landscape = window.matchMedia("(orientation: landscape)").matches;
      const screenH = landscape
        ? Math.min(screen.width, screen.height)
        : Math.max(screen.width, screen.height);
      h = Math.max(h, screenH);
    }
    document.documentElement.style.setProperty("--app-height", `${h}px`);
  };

  window.addEventListener("resize", sync);
  window.addEventListener("orientationchange", sync);
  window.addEventListener("pageshow", sync);
  window.visualViewport?.addEventListener("resize", sync);

  sync();
  // The corrected size can land a few frames after load without any resize event
  // firing in standalone mode, so re-check briefly after launch.
  [100, 300, 1000].forEach((ms) => setTimeout(sync, ms));
}
